import { render, staticRenderFns } from "./ErpModal.vue?vue&type=template&id=181038aa"
import script from "./ErpModal.vue?vue&type=script&lang=js"
export * from "./ErpModal.vue?vue&type=script&lang=js"
import style0 from "./ErpModal.vue?vue&type=style&index=0&id=181038aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports